import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-alertas',
  templateUrl: './alertas.component.html',
  styleUrls: ['./alertas.component.scss']
})
export class AlertasComponent implements OnInit {

  constructor(public rest: RestService) { }
  p3: any[] = [];
  p2: any[] = [];
  p1: any[] = [];

  ngOnInit() {
    this.getNotifications();
  }

  getNotifications() {
    this.rest.getNotifications(1).subscribe((data) => { this.p1 = data['data']; });
    this.rest.getNotifications(2).subscribe((data) => { this.p2 = data['data']; });
    this.rest.getNotifications(3).subscribe((data) => { this.p3 = data['data']; });
  }

  postRead(value) {
    this.rest.postReadNotification(value).subscribe((data) => {
      this.getNotifications();
    });

  }

  getCronAlerts() {
    this.rest.getCron_Notification().subscribe((data) => {
      this.getNotifications();
    });

  }

}
